import React from 'react'
import { FaFacebookF, FaInstagram, FaFacebookMessenger } from "react-icons/fa";
import { FiEye, FiMousePointer, FiDollarSign, FiBarChart2 } from "react-icons/fi";
import './css/facebook_publisher_platform_metrics_card.css'

const FacebookAdsPublisherPlatformMetricsList = ({ ads }) => {

    // Map platform to icon
    const platformIcons = {
        facebook: <FaFacebookF color="#3b5998" size={20} />,
        instagram: <FaInstagram color="#E4405F" size={20} />,
        messenger: <FaFacebookMessenger color="#0084FF" size={20} />,
    };

    // Map metric to icon
    const metricIcons = {
        impressions: <FiEye />,
        clicks: <FiMousePointer />,
        spend: <FiDollarSign />,
        reach: <FiBarChart2 />,
    };



    return (
        <div className="">
            <div className="ads_publisher_platform_metrics_container w-100">
                <div className="heading py-4">
                    <h4>Overview Of Ad Performance Across Platforms</h4>
                    <span>Insights into impressions, clicks, spend, and reach across your active ad campaigns</span>
                </div>
                <div className="content w-100">
                <div className="row g-4">
                {ads?.length>0 && ads.map((ad, index) => (
                    <div className="col-12 col-md-4 col-lg-4" key={index}>
                        <div className="card shadow-sm h-100  publisher_platform_metrics_card" >
                            <div className="card-header d-flex justify-content-between align-items-center bg-light py-3">
                                <div className="d-flex align-items-center gap-2 heading">
                                    {platformIcons[ad.publisher_platform]}
                                    <h4 className="mb-0 text-capitalize ">{ad.publisher_platform}</h4>
                                </div>
                                <small className="text-muted date">
                                    {/* {ad.date_start} - {ad.date_stop} */}
                                </small>
                            </div>
                            <div className="card-body">
                                <div className="row mb-2 align-items-center">
                                    <div className="col-6 d-flex align-items-center gap-1 ">
                                        {metricIcons.impressions} <strong className='text-muted  heading'>Impressions:</strong>
                                    </div>
                                    <div className="col-6">
                                        <span className="aeonik-medium fs-6">{ad.impressions}</span>

                                    </div>
                                </div>
                                <div className="row mb-2 align-items-center">
                                    <div className="col-6 d-flex align-items-center gap-1">
                                        {metricIcons.clicks} <strong className='text-muted heading'>Clicks:</strong>
                                    </div>
                                    <div className="col-6">
                                        <span className="aeonik-medium fs-6">{ad.clicks}</span>


                                    </div>
                                </div>
                                <div className="row mb-2 align-items-center">
                                    <div className="col-6 d-flex align-items-center gap-1">
                                        {metricIcons.spend} <strong className='text-muted heading'>Spend:</strong>
                                    </div>
                                    <div className="col-6">
                                        <span className="aeonik-medium fs-6">${ad.spend}</span>

                                    </div>
                                </div>
                                <div className="row mb-2 align-items-center">
                                    <div className="col-6 d-flex align-items-center gap-1">
                                        {metricIcons.reach} <strong className='text-muted heading'>Reach:</strong>
                                    </div>
                                    <div className="col-6">
                                        <span className="aeonik-medium fs-6">{ad.reach}</span>

                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-6"><strong className='text-muted heading'>CTR:</strong> <span className="aeonik-medium fs-6">{ad.ctr}%</span></div>
                                    <div className="col-6"><strong className='text-muted heading'>CPC:</strong> <span className="aeonik-medium fs-6">${ad.cpc}</span></div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-6"><strong className='text-muted heading'>CPM:</strong> <span className="aeonik-medium fs-6">${ad.cpm}</span></div>
                                    <div className="col-6"><strong className='text-muted heading'>CPP:</strong> <span className="aeonik-medium fs-6">${ad.cpp}</span></div>

                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

                </div>

            </div>



        
        </div>
    )
}

export default FacebookAdsPublisherPlatformMetricsList
